document.addEventListener("DOMContentLoaded", function () {
  const subscribeButtons = document.querySelectorAll(".bs-devshop__subscribe") || [];
  const oneTimeButtons = document.querySelectorAll(".bs-devshop__one-time") || [];
  const atcButtons = [...subscribeButtons, ...oneTimeButtons];
  const addButtons = document.querySelectorAll(".bs-devshop__add-button") || [];
  const purchaseOptions = document.querySelectorAll(
    ".bs-devshop__purchase-options"
  ) || [];
  const productForms = document.querySelectorAll(".bs-devshop__product-form") || [];
  if(atcButtons.length == 0) return;
  atcButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const card = button.closest(".bs-devshop__card");
      const addButton = card.querySelector(".bs-devshop__add-button");
      button.setAttribute("clicked", "true");
      button.classList.add("active");
      document
        .querySelectorAll(".bs-devshop__purchase-option")
        .forEach((option) => {
          if (option !== button) {
            option.removeAttribute("clicked");
            option.classList.remove("active");
          }
        });
      setTimeout(() => {
        addButton.classList.add("active");
      }, 150);

      if (button.querySelector("subscription-price")) {
        addButton.setAttribute(
          "data-variant-id",
          button
            .querySelector("subscription-price")
            .getAttribute("data-variant-id")
        );
        addButton.setAttribute(
          "data-product-id",
          button
            .querySelector("subscription-price")
            .getAttribute("data-product-id")
        );
        addButton.setAttribute(
          "data-section-id",
          button
            .querySelector("subscription-price")
            .getAttribute("data-section-id")
        );
        addButton.setAttribute(
          "data-selling-plan-id",
          button
            .querySelector("subscription-price")
            .getAttribute("data-selling-plan-id")
        );
      }

      addButton.setAttribute(
        "data-button-id",
        button.getAttribute("data-button-id")
      );
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  let isQuickBuyClick = false;

  document.querySelectorAll(".bs-devshop__quick-buy").forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      isQuickBuyClick = true;
      const currentCard = this.closest(".bs-devshop__card");
      const isCurrentlyActive = currentCard.classList.contains("is-active");

      document.querySelectorAll(".bs-devshop__card").forEach((card) => {
        card.classList.remove("is-active");
      });

      if (!isCurrentlyActive) {
        requestAnimationFrame(() => {
          currentCard.classList.add("is-active");
        });
      }

      setTimeout(() => {
        isQuickBuyClick = false;
      }, 100);
    });
  });

  document.addEventListener("click", function (e) {
    if (isQuickBuyClick) return;

    if (
      !e.target.closest(".bs-devshop__quick-buy") &&
      !e.target.closest(".bs-devshop__purchase-options")
    ) {
      document.querySelectorAll(".bs-devshop__card").forEach((card) => {
        card.classList.remove("is-active");
      });
      document.querySelectorAll('.bs-devshop__purchase-option').forEach(button => {
        button.classList.remove('active');
        button.setAttribute("clicked", "false");
      });
      document.querySelectorAll('.bs-devshop__add-button').forEach(button => {
        button.classList.remove('active');
        button.setAttribute("data-button-id", "one-time-button");
      });
    }
  });
});
